<template>
  <div class="info-page">
    <crumbs title="需求对接管理" />
    <div class="info-page__item project-info">
      <div class="project-info__content">
        <div class="left">
          <div class="title">
            <h4>{{ dataInfo.name }}</h4>
          </div>
          <p>
            对接编号：<span>{{ projectInfo.code }}</span>
          </p>
        </div>
        <div class="right">
          <template v-if="inStatus">
            <el-button
              v-if="projectInfo.dockingStatus === 5"
              :loading="isLoading"
              type="success"
              @click="handleSuccessDocking"
              >完成对接</el-button
            >
            <el-button type="danger" @click="handleCreateStatus" plain
              >添加项目流程状态</el-button
            >
            <el-button
              :loading="isLoading"
              type="primary"
              @click="handleCloseDocking"
              >关闭对接</el-button
            >
          </template>
          <template v-if="outStatus"
            ><span class="close">对接已关闭</span></template
          >
          <template v-if="successStatus"
            ><span class="success">对接已完成</span></template
          >
        </div>
      </div>
      <div class="project-info__relation">
        <div class="title">
          <h4>对接人信息</h4>
        </div>
        <div class="detail">
          <div class="left">
            <p>
              <span>申请人姓名</span><i>{{ projectInfo.createByName }}</i>
            </p>
            <p>
              <span>申请人联系方式</span
              ><i>{{ projectInfo.createByPhoneNumber }}</i>
            </p>
            <p>
              <span>申请人账号昵称</span
              ><i>{{ projectInfo.createByAccount }}</i>
            </p>
          </div>
          <div class="right">
            <p>
              <span>发布人姓名</span><i>{{ dataInfo.contact }}</i>
            </p>
            <p>
              <span>发布人联系方式</span><i>{{ dataInfo.phoneNumber }}</i>
            </p>
            <p>
              <span>发布人账号昵称</span><i>{{ dataInfo.createByAccount }}</i>
            </p>
          </div>
        </div>
      </div>
      <div class="project-info__progress">
        <div class="title">
          <h4>当前对接进度</h4>
        </div>
        <ul class="progress">
          <li
            :class="{
              active: item.status === 1
            }"
            v-for="(item, index) in proDockingDataList"
            :key="index"
          >
            <div class="pic"></div>
            <div class="name">{{ item.name }}</div>
          </li>
        </ul>
        <div class="sub-name">对接流程</div>
        <ul class="timeline">
          <li
            v-for="(item, index) in historyDataList"
            :key="index"
            class="fn-clear"
          >
            <div class="fn-left left">{{ item.lastUpdateTime }}</div>
            <div class="fn-left right">
              <h4>{{ item.dockingStatusName }}</h4>
              <p>
                <span>{{ item.description }}</span>
                <a
                  v-for="(file, i) in item.attList"
                  :key="i"
                  :href="file.url"
                  :download="file.name"
                  target="_blank"
                  >{{ file.name }}</a
                >
              </p>
              <div class="circle">
                <i class="el-icon-check"></i>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="project-info__data">
        <div class="title">
          <h4>需求信息</h4>
          <a href="javacript:;" @click="handleLook">查看源需求信息</a>
        </div>
        <div class="detail">
          <div class="line">
            <p>
              <span>持有单位：</span
              ><i>{{
                dataInfo.imCertificationType === 1
                  ? "个人"
                  : dataInfo.companyName
              }}</i>
            </p>
            <p>
              <span>地区：</span><i>{{ dataInfo.area }}</i>
            </p>
            <p>
              <span>发布时间：</span
              ><i>{{ dataInfo.createTime | dateFilterSpace }}</i>
            </p>
            <p>
              <span>截止时间：</span
              ><i>{{ dataInfo.closingTime | dateFilterSpace }}</i>
            </p>
          </div>
          <div class="line">
            <p>
              <span>专业领域：</span><i>{{ dataInfo.specialFieldIdName }}</i>
            </p>
            <p>
              <span>预算上限：</span
              ><i>{{
                dataInfo.budgetUp === 0 ? "面议" : dataInfo.budgetUp + "万元"
              }}</i>
            </p>
            <p>
              <span>技术关键词：</span
              ><i>{{ dataInfo.technologyKeyword || dataInfo.keyWords }}</i>
            </p>
          </div>
          <div class="line">
            <p>
              <span>需求概述：</span><i>{{ dataInfo.description }}</i>
            </p>
          </div>
          <div class="line">
            <p>
              <span>技术指标：</span><i>{{ dataInfo.technologyInfo }}</i>
            </p>
          </div>
        </div>
      </div>
    </div>
    <add-project-status
      v-if="createStatusDialog"
      dataType="dem"
      :projectId="$route.query.id"
      @close="createStatusDialog = false"
      @complete="completetCreateStatus"
    />
  </div>
</template>

<script>
export default {
  name: "demDockingInfo",
  data() {
    return {
      isLoading: false,
      projectInfo: {},
      dataInfo: {},
      proDockingDataList: [],
      historyDataList: [],
      // 添加状态弹框
      createStatusDialog: false
    };
  },
  computed: {
    // 1-对接中，2-对接关闭，3-已完成
    inStatus() {
      return this.projectInfo.projectStatus === 1;
    },
    outStatus() {
      return this.projectInfo.projectStatus === 2;
    },
    successStatus() {
      return this.projectInfo.projectStatus === 3;
    }
  },
  created() {
    this.loadInfo();
  },
  methods: {
    // 加载工程数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("project", "getProjectInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          const {
            project: projectInfo,
            reqData,
            proDockingDataList,
            historyDataList
          } = res;
          this.projectInfo = projectInfo;
          this.dataInfo = reqData;
          this.proDockingDataList = proDockingDataList;
          this.historyDataList = historyDataList;
        } else {
          this.redirectTo();
          this.$message.error(message);
        }
      });
    },
    // 添加项目流程状态
    handleCreateStatus() {
      this.createStatusDialog = true;
    },
    completetCreateStatus() {
      this.createStatusDialog = false;
      this.loadInfo();
    },
    // 关闭工程对接
    handleCloseDocking() {
      this.isLoading = true;
      const { id } = this.$route.query;
      return this.$api("project", "closeDemDocking", {
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadInfo();
        }
      });
    },
    // 成功对接数据对接
    handleSuccessDocking() {
      this.isLoading = true;
      const { id } = this.$route.query;
      return this.$api("project", "successDemDocking", {
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadInfo();
        }
      });
    },
    // 查看需求
    handleLook() {
      const { id } = this.dataInfo;
      this.redirectByPathBlank(
        `/admin/dataManage/demandInfo/modification`,
        {
          id
        },
        this.queryCondition
      );
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/dockingManage/demDockingList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.project-info {
  .project-info__content {
    display: flex;
    justify-content: space-between;
    padding-top: 23px;
    .left {
      .title {
        line-height: 34px;
        font-size: 20px;
      }
      p {
        line-height: 40px;
        font-size: 14px;
        color: #999999;
        span {
          color: #141414;
        }
      }
    }
    .right {
      span {
        line-height: 34px;
        font-size: 14px;
        &.close {
          color: #f23b43;
        }
        &.success {
          color: #074491;
        }
      }
    }
  }
  .project-info__relation {
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 76px;
      padding-bottom: 12px;
      h4 {
        font-size: 20px;
      }
      span {
        font-size: 14px;
        color: #999999;
      }
    }
    .detail {
      display: flex;
      > div {
        flex: 1;
        > p {
          display: flex;
          padding: 6px 0;
          line-height: 22px;
          font-size: 14px;
          span {
            flex: 0 0 120px;
            color: #666666;
          }
          i {
            font-style: normal;
          }
        }
      }
    }
  }
  .project-info__progress {
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 76px;
      padding-bottom: 12px;
      h4 {
        font-size: 20px;
      }
      span {
        font-size: 14px;
        color: #999999;
      }
    }
    .progress {
      display: flex;
      justify-content: space-between;
      li {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        &:nth-child(n + 2) {
          position: relative;
          &::before {
            content: "";
            top: 50%;
            left: 0;
            position: absolute;
            width: 78px;
            height: 14px;
            background-size: 100%;
            background-image: url("~@/assets/images/project_progress_icon2.png");
            transform: translate(-50%, -50%);
          }
          &.active::before {
            background-image: url("~@/assets/images/project_progress_icona2.png");
          }
        }
        &.active .pic {
          background-image: url("~@/assets/images/project_progress_icona1.png");
        }
        .pic {
          width: 50px;
          height: 50px;
          background-size: 100%;
          background-image: url("~@/assets/images/project_progress_icon1.png");
        }
        .name {
          line-height: 54px;
          font-size: 14px;
          color: #141414;
        }
      }
    }
    .sub-name {
      line-height: 56px;
      font-weight: bold;
    }
    .timeline {
      padding: 20px 30px;
      border-radius: 4px;
      background-color: #f7f7f7;
      li {
        line-height: 1;
        font-size: 16px;
        &:first-child {
          .left {
            color: #141414;
          }
          .right {
            color: #666666;
            h4 {
              color: #141414;
            }
            .circle {
              background-color: #074491;
            }
          }
        }
        &:last-child {
          .right {
            padding-bottom: 0;
            // border-left: 2px solid transparent;
          }
        }
        .left {
          width: 230px;
          text-align: center;
          color: #999999;
        }
        .right {
          position: relative;
          box-sizing: border-box;
          width: 600px;
          padding-left: 3em;
          padding-bottom: 28px;
          border-left: 2px solid #cccccc;
          color: #999999;
          p {
            padding-top: 14px;
            line-height: 1;
            font-size: 14px;
            > a {
              line-height: 1.5;
              display: block;
              color: #074491;
              padding-right: 10px;
            }
          }
          .circle {
            position: absolute;
            top: -2px;
            left: -11px;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            line-height: 20px;
            text-align: center;
            color: #fff;
            font-size: 14px;
            background-color: #cccccc;
          }
        }
      }
    }
  }
  .project-info__data {
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 20px;
      height: 60px;
      h4 {
        font-size: 20px;
      }
      a {
        padding-right: 20px;
        font-size: 14px;
        color: #074491;
        background-image: url("~@/assets/images/icon_arrows_right.png");
        background-repeat: no-repeat;
        background-position: right 0 center;
        background-size: 10px auto;
      }
    }
    .detail {
      .line {
        display: flex;
        flex-wrap: wrap;
        > p {
          display: flex;
          margin-right: 60px;
          padding: 6px 0;
          line-height: 22px;
          font-size: 14px;
          span {
            flex: none;
            color: #666666;
          }
          i {
            font-style: normal;
          }
        }
      }
    }
  }
}
</style>
